module.exports = __webpack_public_path__ + "static/media/ncgs3-client-preroll-and-tutorial.ea306098.mp4";